import CheckIcon from '@/assets/check.svg?react';
import Button from '@/components/ui/Button';
import ErrorMessage from '@/components/ui/ErrorMessage';

import {
  type CompanyInvoiceValues,
  formatCompanyAddress,
} from '../helpers/companyInvoice';
import { useLingui } from '@lingui/react';

interface Props {
  values: CompanyInvoiceValues;
  isFromGus: boolean;
  error?: string;
  onEdit: () => void;
  onChangeTaxId: () => void;
}

const CompanyDataCard = ({
  values,
  isFromGus,
  error,
  onEdit,
  onChangeTaxId,
}: Props) => {
  const { i18n } = useLingui();

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-dark-gray-100 bg-white p-4">
      {isFromGus && (
        <span className="caption lg:caption-small flex w-fit items-center gap-1 rounded bg-green-500 p-1.5 leading-4 text-white">
          <CheckIcon width={16} className="shrink-0 [&>path]:fill-white" />
          {i18n.t('Dane pobrane z GUS')}
        </span>
      )}

      <div className="flex flex-col gap-1">
        <p className="body-large-semi break-words text-oxford-blue-500">
          {values.company_name}
        </p>
        <p className="caption-large text-dark-gray-500">
          {formatCompanyAddress(values)}
        </p>
        <p className="caption-large text-dark-gray-500">
          {i18n.t('NIP: {taxId}', { taxId: values.tax_id })}
        </p>
      </div>

      {error && <ErrorMessage errorMessage={error} />}

      <div className="flex flex-col gap-2 sm:flex-row">
        <Button type="button" size="small" onClick={onEdit}>
          {i18n.t('Edytuj dane')}
        </Button>
        <Button
          type="button"
          size="small"
          intent="secondary"
          className="border border-blue-600"
          onClick={onChangeTaxId}
        >
          {i18n.t('Zmień NIP')}
        </Button>
      </div>
    </div>
  );
};

export default CompanyDataCard;
